import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=4c644787&scoped=true&"
import script from "./AppSetting.vue?vue&type=script&lang=ts&"
export * from "./AppSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AppSetting.vue?vue&type=style&index=0&id=4c644787&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c644787",
  null
  
)

export default component.exports